import { isPlatformBrowser } from '@angular/common';
import { InjectionToken, PLATFORM_ID, type Provider } from '@angular/core';

/**
 * schoolbell-e magic-link 세션 교환(`POST /auth/magic-link/:provider/sessions`) 호출 대상
 * — 소비 앱 자신의 API origin(예: `http://localhost:3013`, production은 빈 문자열로 same-origin
 * 유지). `libs/client/staff-http/src/lib/staff-http.config.ts`와 동일한
 * 토큰+`provide*()` 팩토리 패턴 — 각 앱의 `environment.*ApiBaseUrl` 필드명이 서로 달라 팩토리로
 * 흡수한다.
 *
 * `@sbe-spinoff-client/schoolbell-org-link`(이 토큰을 실제로 쓰는 `ErpCallbackComponent`가 있는
 * lib) 대신 이 lib(spinoff-platform)에 둔다 — 그 lib은 라우트에서 lazy-load되는데, 이 토큰은
 * 앱 부팅 시 `app.config.ts`의 `providers`에서 static import로 등록해야 해서 같은 lib에 두면 Nx
 * `enforce-module-boundaries`의 "lazy-loaded lib을 static import"(`noImportsOfLazyLoadedLibraries`)
 * 위반이 된다(2026-08-16 발견). spinoff-platform은 어차피 두 앱 모두 전역적으로 static import만
 * 하므로(lazy-load 없음) 이 충돌이 없다.
 */
export const SCHOOLBELL_ORG_LINK_API_BASE_URL = new InjectionToken<string>(
  'SCHOOLBELL_ORG_LINK_API_BASE_URL',
);

export function provideSchoolbellOrgLinkApiBaseUrl(getBaseUrl: () => string): Provider {
  return {
    provide: SCHOOLBELL_ORG_LINK_API_BASE_URL,
    useFactory: (platformId: object) => (isPlatformBrowser(platformId) ? getBaseUrl() : ''),
    deps: [PLATFORM_ID],
  };
}
